import { Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { DistributionFormControl } from './distribution-form-control';

@Component({
  standalone: false,
  selector: 'app-distribution-form-control',
  templateUrl: './distribution-form-control.component.html',
  styleUrls: ['./distribution-form-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DistributionFormControlComponent),
      multi: true
    }
  ]
})
export class DistributionFormControlComponent
  extends AbstractFormControlComponent<DistributionFormControl>
  implements ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}
}
